import { jsx as a } from "react/jsx-runtime";
import { ThemeProvider as i } from "flowbite-react";
import { createContext as m, useEffect as d, useState as c } from "react";
const l = m({
  isDarkMode: !1,
  setDarkMode: () => {
  }
}), u = (o = !1) => {
  const t = c(o);
  return d(() => {
    const e = window.document.documentElement;
    e.classList.remove(t[0] ? "light" : "dark"), e.classList.add(t[0] ? "dark" : "light");
  }, [t]), t;
}, f = () => {
}, p = ({
  children: o,
  initialDarkMode: t = !1,
  forceDarkMode: e = !1
}) => {
  const [r, s] = u(
    e || t
  );
  d(() => {
    e && !r && s(!0);
  }, [e, r, s]);
  const n = e ? { isDarkMode: !0, setDarkMode: f } : { isDarkMode: r, setDarkMode: s };
  return /* @__PURE__ */ a(l.Provider, { value: n, children: /* @__PURE__ */ a(i, { children: o }) });
};
export {
  l as ThemeContext,
  p as ThemeProvider
};
